export type ISetLastPopedPopover = (
  el: IjQueryElmOrHtmlElm,
  el2: IjQueryElmOrHtmlElm,
  el3?: IjQueryElmOrHtmlElm,
  pos?: 'left' | 'top' | 'right' | 'bottom'
) => void;

export const setLastPopedPopover = (
  el: IjQueryElmOrHtmlElm,
  el2: IjQueryElmOrHtmlElm,
  el3?: IjQueryElmOrHtmlElm,
  pos?: 'left' | 'top' | 'right' | 'bottom'
) => {
  const position = pos || 'left';
  window.DexeroCoreApp.lastPopedPopover = el;
  window.DexeroCoreApp.lastPopedPopoverContent = el2;
  window.DexeroCoreApp.lastPopedPopoverContentPosition = position;
  window.DexeroCoreApp.lastPopedPopoverScrollTable = el3;

  if (
    window.DexeroCoreApp.lastPopedPopoverScrollTable &&
    window.DexeroCoreApp.lastPopedPopoverScrollTable &&
    (window.DexeroCoreApp.lastPopedPopoverScrollTable as IjQueryElm).length
  ) {
    $(window.DexeroCoreApp.lastPopedPopoverScrollTable).on(
      'scroll',
      window.DexeroCoreApp.positionLastPopedPopover
    );
  }

  $(window).scroll(window.DexeroCoreApp.positionLastPopedPopover);
  $(window).resize(window.DexeroCoreApp.positionLastPopedPopover);
};
